import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import siteMessage from "@insite/client-framework/SiteMessage";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getOrderState } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { getExpediteShippingOrderHistoryStateById } from "@TKCCP/Store/Data/ExpediteShippingOrderHistory/ExpediteShippingOrderHistorySelector";
import ApplicationStateTKCCP from "@TKCCP/Store/TKCCPState";
import React, { FC } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationStateTKCCP) => {
    const order = getOrderState(state, state.pages.orderDetails.orderNumber).value;
    const getExpediteShippingState = getExpediteShippingOrderHistoryStateById(state, order?.id!);
    return {
        expediteShippingState: getExpediteShippingState,
        settings: getSettingsCollection(state),
    };
};
export interface ExpediteMsg {
    expediteMsg?: InjectableCss;
}
export const expediteMsgStyles: ExpediteMsg = {
    expediteMsg: {
        css: css`
            text-align: right;
            padding: 0;
            @media screen and (max-width: 767px) {
                text-align: left;
            }
            @media print {
                text-align: left;
            }
        `,
    },
};

type Props = ReturnType<typeof mapStateToProps>;

const DisplayExpediateShipping: FC<Props> = ({ expediteShippingState,settings }) => {
    const enableExpediteShipping= settings?.expediteShippingSetting;
    return (
        <>
            <StyledWrapper {...expediteMsgStyles.expediteMsg}>
                {enableExpediteShipping && expediteShippingState.value?.isExpediteShipping
                    ? siteMessage("OrderDetailsIfExpediteShipping")
                    : siteMessage("OrderDetailsIfNotExpediteShipping")}
            </StyledWrapper>
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(DisplayExpediateShipping),

    definition: {
        group: "Order Details",
    },
};

export default widgetModule;
